import React, { createContext, useState } from 'react'

import { filterKeys } from '../constants'
import useParticipantsFilter from '../hooks/useParticipantsFilter'

export const ParticipantsContext = createContext()

const ParticipantsContextProvider = props => {
    const [selectedFilter, setSelectedFilter] = useState(filterKeys.DEFAULT)

    const filters = [
        {
            key: filterKeys.DEFAULT,
            title: 'Default',
            onClick: () => setSelectedFilter(filterKeys.DEFAULT),
        },
        {
            key: filterKeys.ALPHABETICAL,
            title: 'Alphabetical',
            onClick: () => setSelectedFilter(filterKeys.ALPHABETICAL),
        },
        {
            key: filterKeys.VIDEO_OFF_FIRST,
            title: 'Video Off first',
            onClick: () => setSelectedFilter(filterKeys.VIDEO_OFF_FIRST),
        },
        {
            key: filterKeys.AUDIO_OFF_FIRST,
            title: 'Audio Off first',
            onClick: () => setSelectedFilter(filterKeys.AUDIO_OFF_FIRST),
        },
        {
            key: filterKeys.ELSEWHERE,
            title: 'Elsewhere',
            onClick: () => setSelectedFilter(filterKeys.ELSEWHERE),
        },
    ]

    const filteredParticipants = useParticipantsFilter(selectedFilter)

    const value = {
        filters,
        selectedFilter,
        setSelectedFilter,
        filteredParticipants,
    }

    return <ParticipantsContext.Provider value={value} {...props} />
}

export default ParticipantsContextProvider
